export default "__VITE_ASSET__fe2d5780__"